@let text = this.text();

{{ text }}
